import { Translator } from 'Translator';
import { Filter } from 'model/Filters';
import LocalSpeaksPopover from 'modules/common/Popovers/LocalSpeaksPopover';
import React, { useState } from 'react';
import { analyticsTrack } from 'utils/analytics';

import FilterTrigger from './FilterTrigger';

interface LocalSpeaksTriggerProps {
  isMobile: boolean;
  selectedLanguages: Filter;
}

function renderText(selectedLanguages) {
  if (!selectedLanguages || selectedLanguages.subOptions.length === 0) {
    return Translator.translate(
      'SearchPage.SearchResults.localSpeaks',
      {},
      true,
      'Local speaks',
    );
  }
  if (selectedLanguages.subOptions.length > 1) {
    return Translator.translate(
      'SearchPage.LanguageFilter.languages',
      { nr: selectedLanguages.subOptions.length },
      true,
      '{nr} languages',
    );
  }
  return Translator.translate(
    'SearchPage.LanguageFilter.language',
    { nr: 1 },
    true,
    '{nr} language',
  );
}

function getInitialLanguages(selectedLanguages) {
  return selectedLanguages
    ? selectedLanguages.subOptions.map((subOption) => subOption.id)
    : [];
}

function LocalSpeaksTrigger({
  isMobile,
  selectedLanguages,
}: LocalSpeaksTriggerProps) {
  const [show, toggleShow] = useState(false);

  const togglePopover = () => {
    if (!show) {
      analyticsTrack(
        {
          type: 'click',
          subject: `open filter`,
          value: { filterCategory: 'local speaks' },
          valueString: 'local speaks',
        },
        {
          category: 'Search page',
          action: 'click',
          label: 'Filter local speaks',
        },
      );
    }
    toggleShow(!show);
  };

  const closePopover = () => {
    toggleShow(false);
  };

  return (
    <div>
      <FilterTrigger
        isMobile={isMobile}
        destination="/filter/languages/"
        text={renderText(selectedLanguages)}
        togglePopover={togglePopover}
        isActive={!!selectedLanguages}
      />
      {show && (
        <LocalSpeaksPopover
          initialSelectedLanguages={getInitialLanguages(selectedLanguages)}
          onClose={closePopover}
        />
      )}
    </div>
  );
}

export default LocalSpeaksTrigger;
